export default __webpack_public_path__ + "static/media/objectives_icon_4.9b3e8f69.png";